import React, { useContext } from 'react';
import { ExportConfigurationsPane } from '../../../../components/ExportItems';
import { AssetExportConfigurationContext } from '../../../../../context/AssetExportConfigurationContext';

export default function AssetExportConfigurationSettingsPane() {
  const { assetExportConfigurations, assetExportConfigurationsLoading } = useContext(AssetExportConfigurationContext);

  return (
    <ExportConfigurationsPane
      configurations={[...assetExportConfigurations.values()]}
      loading={assetExportConfigurationsLoading}
    />
  );
}
